import piexif from 'piexif-ts'

export const removeImageMetadata = (base64Image: string): string => {
    try {
        const isDataUrl = base64Image.startsWith('data:');
        const dataUrl = isDataUrl
            ? base64Image
            : 'data:image/jpeg;base64,' + base64Image;

        const result = piexif.remove(dataUrl);

        return isDataUrl ? result : result.replace(/^data:image\/jpeg;base64,/, '');
    } catch (e) {
        return base64Image;
    }
};

export const checkDocumentData = async (documentImage: string, requestId: string, companyId: string, typeDoc?: string) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/document/ocr`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                documentImage,
                requestId,
                companyId,
                type: typeDoc
            }),
        });

        const results = await res.json();

        if (!res.ok) {
            return {
                validation: false,
                data: undefined,
                message: results.message || results.error
            };
        }

        return {
            validation: results.validation === true,
            data: results.data,
            message: results.message || results.error,
            extracted: results.extracted ?? null
        };
    } catch (err) {
        return {
            validation: false,
            data: undefined,
            message: undefined,
            error: err
        };
    }
};

export const getQRCode = async (companyId: string, requestId: string, passport: string) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/qrcode`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          url: process.env.REACT_APP_URL + `/${companyId}/${requestId}/si/${passport}/p`
        }),
      }
    );

    const res = await response.json()

    return res
}

export const fetchDocumentImage = async (requestId: string): Promise<string | null> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/admin/doc-image`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ requestId, type: 'document' }),
        });
        if (!res.ok) return null;
        const data = await res.json();
        return data.message?.content ?? null;
    } catch {
        return null;
    }
};

export const getQRCodeForUrl = async (url: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/qrcode`,
        {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ url }),
        }
    );

    return response.json();
}